import i18n from 'modules/core/lib/i18n'

import { CostCenterAssignmentBaseCard } from 'modules/finance/components/CostCenterAssigments/Assigments/BaseCard'
import { ManageAssignments } from 'modules/finance/components/CostCenterAssigments/Assigments/ManageAssignments'
import { CostCenterAssignment } from 'modules/finance/lib/costCenterAssignments'

import { CreateButton } from './components/CreateButton'

interface Props {
  legalEntityIds: number[]
  resourceId: number
  onCancel: () => void
  onSave: () => void
  allAssignments: CostCenterAssignment[]
}

export const NewAssignmentCard = ({
  legalEntityIds,
  resourceId,
  onCancel,
  onSave,
  allAssignments,
}: Props) => {
  return (
    <CostCenterAssignmentBaseCard focus>
      <ManageAssignments
        legalEntityIds={legalEntityIds}
        resourceId={resourceId}
        title={i18n.t('finance.cost_centers.assignments.new_assignment_card.title')}
        description={i18n.t('finance.cost_centers.assignments.new_assignment_card.description')}
        onCancel={onCancel}
        onSave={onSave}
        allAssignments={allAssignments}
        customSaveButton={(assignmentsToCreate, _assignmentsToUpdate, disabled) => (
          <CreateButton
            assignments={assignmentsToCreate}
            resourceId={resourceId}
            disabled={disabled}
            onSave={onSave}
          />
        )}
      />
    </CostCenterAssignmentBaseCard>
  )
}
